import { Actor, Engine, Vector, Color, Line } from 'excalibur';
import { Virus } from '../Virus';

export class ComplementBolt {

    static fire(engine: Engine, startPos: Vector, target: Virus, onKill: (v: Virus) => void, bounces: number = 3) {
        if (!target || !target.isPoolActive()) return;

        // 1. Damage the initial target
        const killed = target.takeDamage(50);
        if (killed) {
            onKill(target);
            // If killed, we can still bounce from its last position
        }

        // 2. Visual: Draw a "Lightning" line for 100ms
        const bolt = new Actor({ pos: Vector.Zero, z: 100 });
        const line = new Line({
            start: startPos,
            end: target.pos,
            color: Color.Cyan,
            thickness: 3
        });
        bolt.graphics.use(line);
        engine.add(bolt);
        // Remove visual after a split second
        engine.clock.schedule(() => bolt.kill(), 100);

        // 3. Recursive Bounce Logic
        if (bounces > 0) {
            // Find a NEW target close to the CURRENT target
            const neighbors = engine.currentScene.actors
                .filter(a => a instanceof Virus && a !== target && a.isPoolActive()) as Virus[];

            let closest: Virus | null = null;
            let minDist = 150 * 150; // Max bounce range 150px squared

            for (const enemy of neighbors) {
                // Simple distance check
                const dist = target.pos.squareDistance(enemy.pos);
                if (dist < minDist) {
                    minDist = dist;
                    closest = enemy;
                }
            }

            if (closest) {
                // Delay the bounce slightly for "travel time" feel
                engine.clock.schedule(() => {
                    ComplementBolt.fire(engine, target.pos, closest!, onKill, bounces - 1);
                }, 50);
            }
        }
    }
}
